export default __webpack_public_path__ + "static/assets/10c897b92dcf6f63aa0ad8bca1fbb89d.png";